import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard } from "@fortawesome/free-regular-svg-icons";

export default class ListIconWrap extends Component {
    render() {
        const { updateShowProductionListModal } = this.props;
        return (
            <div className="col-1">
                <button
                    type="button"
                    className="btn"
                    onClick={(e) => updateShowProductionListModal(true)}>
                    <FontAwesomeIcon icon={faClipboard} />
                </button>
            </div>
        );
    }
}
